import { ColumnLabel } from "@components/Table/Settings/Toolbar";
import { getAllPaymentMethods, createPaymentMethod, editPaymentMethod, inactivatePaymentMethod } from "@services/form";
import { useIntl } from "react-intl";
import { useT, useLocalizedName } from "@hooks";
import SettingsCrudPage from "../SettingsCrudPage";
import SettingsNameDialogs from "../SettingsNameDialogs";
import useSettingsCrudPage from "../useSettingsCrudPage";

const defaultColumnOrder = ["name"];

const PaymentMethodsPage = () => {
  const t = useT();
  const localizedName = useLocalizedName();
  const { locale } = useIntl();

  const crud = useSettingsCrudPage({
    translationPrefix: "settings.paymentMethod",
    reloadKey: locale,
    fetchService: getAllPaymentMethods,
    mountOption: (data: any[]) =>
      data?.map((res) => ({
        id: res.id,
        name: localizedName(res),
        date: "",
        active: res?.active,
      })),
    createService: (value) =>
      createPaymentMethod({
        id: null,
        name: value,
        displayOrder: 0,
        active: true,
        categoryIds: [],
      }),
    editService: (selected, value) =>
      editPaymentMethod({
        id: selected.id,
        name: value,
        displayOrder: 0,
        active: true,
        categoryIds: [],
      }),
    inactivateService: inactivatePaymentMethod,
  });

  const columnLabels: ColumnLabel = {
    id: "1",
    name: t("settings.paymentMethod.column.name"),
    date: "",
  };

  return (
    <SettingsCrudPage
      crud={crud}
      translationPrefix="settings.paymentMethod"
      columnLabels={columnLabels}
      defaultColumnOrder={defaultColumnOrder}
    >
      <SettingsNameDialogs
        crud={crud}
        newTitle={t("settings.paymentMethod.dialog.newTitle")}
        editTitle={t("settings.paymentMethod.dialog.editTitle")}
        newPlaceholder={t("settings.paymentMethod.placeholder.new")}
        editPlaceholder={t("settings.paymentMethod.placeholder.edit")}
        resetDuplicateAlert
      />
    </SettingsCrudPage>
  );
};

export default PaymentMethodsPage;
